import { useState, useRef, useEffect } from 'react';

type Props = {
  logicCount: number;
  onShowLogic: () => void;
  onShowAdvanced: () => void;
  onInsertBelow: () => void;
  onRemove: () => void;
};

export default function QuestionMenu({
  logicCount,
  onShowLogic,
  onShowAdvanced,
  onInsertBelow,
  onRemove,
}: Props) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      if (rootRef.current && !rootRef.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const close = () => setOpen(false);

  return (
    <div className="q-menu" ref={rootRef}>
      <button
        type="button"
        className="q-menu-trigger"
        onClick={(e) => {
          e.stopPropagation();
          setOpen(!open);
        }}
        title="题目操作"
      >
        ⋮
      </button>
      {open && (
        <div className="q-menu-popup" role="menu">
          <button className="q-menu-item" onClick={() => { close(); onShowLogic(); }} disabled title="本期占位">
            <span>选项样式</span>
            <i>›</i>
          </button>
          <button className="q-menu-item" onClick={() => { close(); onShowLogic(); }} disabled title="本期占位">
            <span>选项填空</span>
            <i>›</i>
          </button>
          <button className="q-menu-item" onClick={() => { close(); onShowLogic(); }}>
            <span>题目显示逻辑</span>
            {logicCount > 0 && <span className="q-menu-count">{logicCount}</span>}
          </button>
          <button className="q-menu-item" onClick={() => { close(); onInsertBelow(); }}>
            <span>下方插入新题</span>
          </button>
          <div className="q-menu-divider" />
          <button className="q-menu-item" onClick={() => { close(); onShowAdvanced(); }}>
            <span>高级设置</span>
          </button>
          <div className="q-menu-divider" />
          <button className="q-menu-item q-menu-item-danger" onClick={() => { close(); onRemove(); }}>
            <span>删除</span>
          </button>
        </div>
      )}
    </div>
  );
}